export default function StepperControl(props: {
  steps: {
    stepNo: number;
    highlighted?: boolean;
    selected?: boolean;
    completed?: boolean;
  }[];
  currentStep: number;
  handleClick: any;
  buttonLoading:boolean
}) {
  const { steps, currentStep, handleClick, buttonLoading } = props;
  const currentStepText = currentStep === steps.length ? "submit" : "next"
  return (
    <div className="mt-4 flex flex-col justify-between px-3 pt-2 md:flex-row md:px-8">
      {currentStep === steps.length - 3 ? (
        <div />
      ) : (
        <button
          onClick={() => handleClick()}
          className={`mb-3 cursor-pointer rounded-xl bg-lightPrimary px-16 py-2 font-medium text-navy-700 transition duration-200 dark:bg-white/5 dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20`}
        >
          Prev
        </button>
      )}

      <button
        onClick={() => handleClick(currentStepText)}
        disabled={buttonLoading}
        className={`px-4 py-2 text-white transition-colors duration-150 bg-blue-600 rounded-lg focus:shadow-outline hover:bg-blue-700 ${
          buttonLoading && 'cursor-not-allowed opacity-75'
        }`}
      >
      {buttonLoading ? (
        <>
          <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 0116 0H4z"></path>
          </svg>
          Loading...
        </>
      ) : (
        currentStep === steps.length ? "Submit" : "Next"
      )}
  


        
      </button>
    </div>
  );
}
